let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kUAIU")).then(() => parcelRequire('8j0Ak'));